import script from "./BaseModalContentComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseModalContentComponent.vue?vue&type=script&lang=ts&setup=true"

import "./BaseModalContentComponent.vue?vue&type=style&index=0&id=07873c95&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07873c95"]])

export default __exports__